import React, {FC} from 'react';

import {LineupData, LineupPlayer, Team} from 'utils/types';
import './styles.scss';

import sprite from 'assets/svg/match_timeline_iconsprite.svg';

const PlayerRow = ({player}: {player: LineupPlayer}) => (
  <div className="WidgetLineup__player">
    <span className="WidgetLineup__number">{player.number}</span>
    <span className="WidgetLineup__name">{player.name}</span>
    {/*
    player.events.map(e => (
      <span className={`WidgetLineup__event WidgetLineup__event--${e.type}`} key={e.type}>
        <svg className="WidgetLineup__eventIcon">
          <use href={`${sprite}#${e.type}`} />
        </svg>
        {e.count}
      </span>
    ))
    */}
    <span className="WidgetLineup__position">{player.position}</span>
  </div>
);

interface Props {
  team: Team;
  lineupData: LineupData | null;
}

const WidgetLineups: FC<Props> = ({team, lineupData}: Props) =>
  !lineupData ? null : (
    <section className={`WidgetLineup WidgetLineup--${team}`}>
      <h3 className="WidgetLineup__header">{lineupData.teamName}</h3>
      <h4 className="WidgetLineup__subtitle">ΑΡΧΙΚΗ 11ΑΔΑ</h4>
      {lineupData.main.map(p => (
        <PlayerRow player={p} key={p.name} />
      ))}
      <h4 className="WidgetLineup__subtitle">ΑΝΑΠΛΗΡΩΜΑΤΙΚΟΙ</h4>
      {lineupData.bench.map(p => (
        <PlayerRow player={p} key={p.name} />
      ))}
    </section>
  );

export default React.memo(WidgetLineups);
